import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { VerifyIdentityDrawer } from '../components/client/VerifyIdentityDrawer';
import { useAuth } from './AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

const VerifyContext = createContext({
  openVerify: () => {}, closeVerify: () => {},
  kycStatus: 'not_submitted', isOpen: false,
  refreshKyc: () => {},
});

export const useVerify = () => useContext(VerifyContext);

export const VerifyProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [kycStatus, setKycStatus] = useState('not_submitted');
  const { token } = useAuth();

  const refreshKyc = useCallback(async () => {
    if (!token) { setKycStatus('not_submitted'); return; }
    try {
      const r = await axios.get(`${API}/api/kyc/status`, { headers: { Authorization: `Bearer ${token}` } });
      setKycStatus(r.data?.status || 'not_submitted');
    } catch { /* noop */ }
  }, [token]);

  useEffect(() => { refreshKyc(); }, [refreshKyc]);

  const isPending = ['document_uploaded', 'pending', 'under_review'].includes(kycStatus);

  const openVerify  = useCallback(() => {
    // When already pending review, the drawer refuses to re-open; caller can surface a toast if desired.
    if (isPending) return;
    setOpen(true);
  }, [isPending]);
  const closeVerify = useCallback(() => { setOpen(false); refreshKyc(); }, [refreshKyc]);

  return (
    <VerifyContext.Provider value={{ openVerify, closeVerify, isOpen: open, kycStatus, isPending, refreshKyc }}>
      {children}
      <VerifyIdentityDrawer open={open} onClose={closeVerify} />
    </VerifyContext.Provider>
  );
};
